import { API_BASE_URL } from "../../config";

const apiBase = () => String(API_BASE_URL || "").replace(/\/$/, "");

const fmtCash = (n) => {
  const v = Number(n) || 0;
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: v >= 1000 ? 0 : 2,
  }).format(v);
};

/** Share URL for a bet house (OG → bet detail screen). */
export const buildHouseShareLink = (houseId) => {
  const id = String(houseId || "").trim();
  if (!id) return "";
  const base = apiBase();
  if (base) return `${base}/share/house/${encodeURIComponent(id)}`;
  if (typeof window === "undefined") return "";
  return `${window.location.origin}/app/bethouse/${encodeURIComponent(id)}`;
};

export const buildHouseShareText = (house) => {
  const name = house?.name || "A BetBond house";
  const available = fmtCash(house?.amountAvailable);
  const fixtures = (house?.fixtures || []).filter((f) => f && (f._id || f.fixtureId));
  const count = fixtures.length;
  const first = fixtures[0];
  const fx =
    first?.teams?.home?.name && first?.teams?.away?.name
      ? first
      : first?.fixtureId?.teams?.home?.name
        ? first.fixtureId
        : null;
  const match =
    fx?.teams?.home?.name && fx?.teams?.away?.name
      ? `${fx.teams.home.name} vs ${fx.teams.away.name}`
      : null;
  const bits = [
    `${name} · ${available} available · ${count} fixture${count === 1 ? "" : "s"}`,
  ];
  if (match) bits.push(match);
  bits.push("Open on BetBond:");
  return bits.join(" · ");
};
